// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { v4 as uuidv4 } from 'uuid';
import { PartyCredentialRequirement } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';

export interface ClaimRequirementElement {
  id: string;
  property: string;
  value: string;
}

export interface PartyCredentialRequirementElement {
  id: string;
  issuer: string;
  requiredClaims: ClaimRequirementElement[];
}
export interface ClaimRequirement {
  id: string;
  property: string;
  value: string;
}

export interface CredentialRequirement {
  id: string;
  issuer: string;
  requiredClaims: ClaimRequirement[];
}
export const credentialRequirementsToTuples = (requirements: CredentialRequirement[]) => {
  return requirements.map(({ issuer, requiredClaims }) => ({
    issuer,
    requiredClaims: requiredClaims.map(({ property, value }) => ({
      _1: property,
      _2: value,
    })),
  }));
};

export const toPartyCredentialRequirements = (
  requirements: PartyCredentialRequirementElement[],
) => {
  return requirements.map(({ issuer, requiredClaims }) => ({
    issuer,
    requiredClaims: requiredClaims.map(({ property, value }) => ({
      _1: property,
      _2: value,
    })),
  }));
};

export const fromPartyCredentialRequirements = (requirements: PartyCredentialRequirement[]) => {
  return requirements.map(({ issuer, requiredClaims }) => ({
    id: uuidv4(), // Generate unique ID for each element
    issuer,
    requiredClaims: requiredClaims.map(({ _1, _2 }) => ({
      id: uuidv4(), // Generate unique ID for each element
      property: _1,
      value: _2,
    })),
  }));
};
